import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModule } from 'src/app/auth/auth.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EvidenzeComponent } from './evidenze.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AuthModule
  ],
  declarations: [
    EvidenzeComponent
  ]
})
export class EvidenzeModule { }
